import { computed, ref, watch } from 'vue'
import { defineStore } from 'pinia'
import methodEditorStore from '@/stores/method-editor'
import { setNavLock } from '@/services/navlock'
import type { Status, Action } from '@/models/jira-enums-generated'

export default defineStore('jira-checkboxes', () => {
	const selectedCheckboxes = computed(() => methodEditor.massEdit.selected)
	const isJiraMode = ref(false)
	const action = ref<Action | undefined>()
	const isShowModal = ref(false)
	const isSomethingWrong = ref(false)
	const jiraStatus = ref<Status | undefined>()
	const methodEditor = methodEditorStore()

	watch(selectedCheckboxes, () => {
		setNavLock('jira-checkboxes', selectedCheckboxes.value.length > 0)
	})


	return {
		selectedCheckboxes,
		isShowModal,
		isJiraMode,
		isSomethingWrong,
		action,
		jiraStatus,
	}
})
